import React, { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';
import { Spin } from 'antd';
import { apiScopes } from '../../services/authConfig';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      instance.loginRedirect({
        scopes: apiScopes,
        redirectStartPage: window.location.pathname
      }).catch((error) => {
        console.error('Login redirect failed:', error);
      });
    }
  }, [isAuthenticated, inProgress, instance]);

  if (inProgress === InteractionStatus.Login) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh', 
        backgroundColor: 'rgba(245, 245, 245, 1)'
      }}>
        <Spin size="large" tip="Authenticating..." />
      </div>
    );
  }

  if (!isAuthenticated && inProgress === InteractionStatus.None) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;